(function () {
    'use strict';

    angular
        .module('sodCommon')
        .filter('userProfileImage', userProfileImage);

    function userProfileImage(lodash, md5, $filter) {
        const defaultImageUrl = 'https://content.recruiterpal.com/app/assets/images/common/default.jpeg';
        const gravatarUrl = 'https://www.gravatar.com/avatar/{0}?d=' + defaultImageUrl;
        return function(user) {
            // first: determine if there are any user_image in user object
            if (lodash.has(user, 'image_url')) {
                if (!lodash.isEmpty(user.image_url)) {
                    return user.image_url;
                }
            }

            // second: determine if there are any user email provider. if has, get from gravatar and provides the default image url over as well
            if (lodash.has(user, 'email')) {
                const userEmailMd5 = md5.createHash(user.email);
                const generatedGravatarUrl = $filter('stringFormat')(gravatarUrl, [userEmailMd5]);
                return generatedGravatarUrl;
            }

            // otherwise, use the default image url
            return defaultImageUrl;
        };
    }
})();